import React from 'react';
import '../CampanaInfo/CampanaInfo.css';
import parse from 'html-react-parser';
import { confirmAlert } from 'react-confirm-alert';

const Opcion2 = (props) => {
  const {
         disponible,
         estado,
         askForVote,
         nombre,
         descripcion,
         pregunta1,
         pregunta2,
         idCandidato1,
         idCandidato2,
         Opcion1,
         Opcion2,
         id,
         Foto
       } = props;

       const trucateText = (text) => {
        let text2=text;
        const myArray = text.split(".");
        
        if (myArray.length>1)
          return parse(myArray[0]+'.');
        else
          return parse(text2);
    
      }
      
      const seeMore = (Nombre, Foto, Descripcion) => {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className='see-more-container'>
                <h1 className="see-more-name">{ Nombre }</h1>
                <img className="see-more-image" src={ Foto } alt={ Nombre }></img>
                <div className="see-more-description">{parse(Descripcion)}</div>
                <div className="see-more-button-container">
                  <button className="button-modal center" onClick={onClose}>Regresar</button>
                </div>
              </div>
            );
          }
        });
      }
    
  return (
    <li className="cards_item" key={id}>
      <div className="card" style={{ backgroundImage: "url(/fondos/Fondo5.jpg)" }}>
          <div className="image">
                <img src={Foto } className="candidato" alt={ nombre }></img>
          </div>
          <h2 className="card_title">{nombre}</h2>
          <div>
            { trucateText(descripcion) }
          </div>
          <center>
            <button 
              className="button-candidate"  
              onClick={e => seeMore(nombre, Foto, descripcion)} 
              id={ "ver"+nombre }>
              Ver Más
            </button>
            <div>¿Está deacuerdo con la propuesta?</div>
            <br/>
            <button
              disabled={estado === "Allow" && disponible > 0 ? "" : "disabled"}
              className={estado === "Allow" && disponible > 0 ? "button-candidate button-candidate-double" : "button-candidate-disabled button-candidate-double"}
              onClick={e => askForVote(idCandidato1, pregunta1, e, Opcion1)}
            >
              {Opcion1}
            </button>
            <button
              disabled={estado === "Allow" && disponible > 0 ? "" : "disabled"}
              className={estado === "Allow" && disponible > 0 ? "button-candidate button-candidate-double no-botton" : "button-candidate-disabled button-candidate-double"}
              onClick={e => askForVote(idCandidato2, pregunta2, e, Opcion2)}
            >
              {Opcion2}
            </button>
        </center>
      </div>
    </li>
  );
};

export default Opcion2;
